const types = {
  SET_LISTA_VINCULOS_DOCUMENTO: 'SET_LISTA_VINCULOS_DOCUMENTO',
  SET_DOCUMENTO_AGREGADOR: 'SET_DOCUMENTO_AGREGADOR',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types
